import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { addDutyFeesPaymentHistory, getSASToBlob, pendingDutyFeesPayment } from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import Grid from '@mui/material/Grid';
const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const DutyFee = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Duty Fee Payment'))

    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedDutyFees, setSelectedDutyFees] = useState(null);
    const [approvalrows, setApprovalrows] = useState([]);
    const [file, setFile] = useState('');


    const [options, setOptions] = useState({
        date: '',
        date_error: '',
        pay_num: '',
        pay_num_error: '',
        payment_type: '',
        payment_type_error: '',
        bank: null,
        bank_error: '',
        amount: '',
        amount_error: '',
        rate: '',
        rate_error: '',
        func_amount: 0
    });

    const paymentOptions = [
        { label: "CHEQUE", value: "CHEQUE" },
        { label: "NEFT", value: "NEFT" },
        { label: "BANK TRANSFER", value: "BANK TRANSFER" },
    ];

    const bankOptions = [
        { label: "ICICI BANK", value: "ICICI BANK" },
        { label: "SBI", value: "SBI" },
        { label: "AXIS BANK", value: "AXIS BANK" },
        { label: "BANK OF BARODA", value: "BANK OF BARODA" },
    ];

    const handleInputChange = (value, input_name) => {
        
        let prev = {...options};
        prev[input_name] = value;

        if(input_name == 'amount' || input_name == 'rate'){
            prev['func_amount'] = Number(prev['amount']) * Number(prev['rate']);
        }

        

        setOptions(prev);
    
}

    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleModal = () => {
        setModalIsOpen(prev => !prev);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        {
            field: 'payment_no',
            headerName: 'Payment No.',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'duty_fees_no',
            headerName: 'Duty Fee No.',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'duty_fee',
            headerName: 'Duty Fee',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'date',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            headerName: 'Date',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            // headerAlign: 'center',
            // cellClassName: 'center-aligndata',
        },
        {
            field: 'pay_num',
            headerName: 'Pay Num',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'bank',
            headerName: 'Bank',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'amount',
            headerName: 'Amount',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'rate',
            headerName: 'Rate',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'func_amount',
            headerName: 'FuncAmt',
            headerClassName: 'break-header',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
    ];

    // const approvalrows = [
    //     { id: 1, Sl_No: 1, payment_no:12345668, duty_fee_no:245566, date: '28-03-2024', pay_num: 'Pay01', bank: 'Axis', amount: 100000, rate: 1, func_amt: 30000, },
    //     { id: 2, Sl_No: 2,payment_no:12345668, duty_fee_no:245566, date: '28-03-2024', pay_num: 'Pay01', bank: 'Axis', amount: 100000, rate: 1, func_amt: 30000, },
    // ];
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const handleSubmit = async () => {
        try {
            let hasError = false;
            let newOptions = {...options};
            if(!newOptions.date){
                newOptions.date_error = 'Date is required!';
                hasError = true;
            }


            if(!newOptions.bank){
                newOptions.bank_error = 'Bank is required!';
                hasError = true;
            }

            if(!newOptions.amount){
                newOptions.amount_error = 'Amount is required!';
                hasError = true;
            }

            if(!newOptions.rate){
                newOptions.rate_error = 'Rate is required!';
                hasError = true;
            }

            if(hasError){
                setOptions(newOptions);
                return;
            }


            /*
                invoice_id: bigint
                customs_id: bigint
                payment_date: Date
                payment_ref_no: string
                bank: string
                payment_type: string
                amount: number
                rate: number
                func_amount: number
            */

            const payload = {
                invoice_id: selectedInvoice.id,
                customs_id: selectedDutyFees.id,
                payment_date: dayjs(options.date).format('YYYY-MM-DD'),
                payment_ref_no: options.pay_num,
                bank: options.bank.value,
                payment_type: options.payment_type.value,
                amount: options.amount,
                rate: options.rate,
                func_amount: options.func_amount
            };

            console.log("payload to be sent:", payload);
            
            if(payload.payment_ref_no == ''){
                delete payload.payment_ref_no;
            }

            if (file) {
                const response =  await getSASToBlob({uploadType:'DUTY_FEE'})
     
                const fetchOptions = {
                    method: 'PUT',
                    body: file,
                    headers: {
                        'x-ms-blob-type': 'BlockBlob',
                        'Content-Type': file.type 
                    },
                }
                 if(response.statusCode===200 && response.data.preSignedUrl){
                    
                     try {
                         const res = await fetch(response.data.preSignedUrl, fetchOptions);
             
                         if (res.ok) {
                            payload.blob_name = response.data.blobName
                            payload.file_name = file.name
                         }
                     } catch (error) {
                         console.error('Error uploading file:', error);
                         toast.error('Error uploading file')
                         return
                     }
                     
                 }
             }

            const response = await addDutyFeesPaymentHistory(payload);
            
            if(response.statusCode == 200){
                toast.success("Successfully created the Duty Fees Charges");
                setModalIsOpen(false);
                    setSelectedInvoice(null);
                    pendingDutyFeesPaymentFromBackend();
            }


        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        }
    }

    const pendingDutyFeesPaymentFromBackend = async () => {
        try {

          const response = await pendingDutyFeesPayment();
            
          console.log("pendingDutyFeesPayment response:", response);

          setInvoiceList(response.data.pendingInvoice.map(el => ({...el, label: el.invoice_number})));

        } catch (error) {
          toast.error("Error in fetching invoice data");
          console.log(error);
        }
    };

    useEffect(() => {
        pendingDutyFeesPaymentFromBackend()
        // searchFreightChargeFromBackend();
    }, []);

    useEffect(() => {
        setOptions({
            date: '',
        date_error: '',
        pay_num: '',
        pay_num_error: '',
        payment_type: '',
        payment_type_error: '',
        bank: null,
        bank_error: '',
        amount: '',
        amount_error: '',
        rate: '',
        rate_error: '',
        func_amount: 0
        });

        setFile('');

        setSelectedDutyFees(null);
        
    }, [selectedInvoice, invoiceList]);

    useEffect(() => {
        if(selectedDutyFees){

            const formattedProducts = selectedDutyFees.procurementDutyFeesPayment.map((payment, index) => ({
                id: payment.id, // Assuming index + 1 as ID
                Sl_No: index + 1, // Serial Number
                invoice_no: selectedInvoice.invoice_number,
                duty_fees_no: selectedDutyFees.duty_fees_no,
                date: payment.payment_date,
                pay_type: payment.payment_type,
                bank: payment.bank,
                amount: payment.amount,
                rate: payment.rate,
                func_amount: payment.func_amount,
                payment_no: payment.payment_no
            }));
            setApprovalrows(formattedProducts)
        } else {
            setApprovalrows([]);
        }
    }, [selectedDutyFees]);

    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center  justify-content-between mb-2 gap-2'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>Duty Fee</p>
                                            <div>
                                                <Autocomplete
                                                    className="invoice_autofield"
                                                    // id={`product-category`}
                                                    sx={{ width: 190 }}
                                                    options={invoiceList}
                                                    value={selectedInvoice}
                                                    onChange={(e, value) => setSelectedInvoice(value)}

                                                    // value={productCategoryObj.find(option => option.value === productCategory)}
                                                    // onChange={handleProductCategoryChange}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Invoice No"
                                                        />
                                                    )}
                                                />
                                            </div>
                                            {/* <div>
                                                <Autocomplete
                                                        className="invoice_autofield"
                                                        // id={`product-category`}
                                                        sx={{ width: 195 }}
                                                        options={selectedInvoice?.procurementCustomsDetails.map(el => ({...el, label:el.duty_fees_no})) || []}
                                                        value={selectedDutyFees}
                                                        onChange={(e, value) => setSelectedDutyFees(value)}
                                                        disabled={!selectedInvoice}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Duty Fees No"
                                                            />
                                                        )}
                                                />
                                            </div> */}
                                            {/* <div className="d-flex gap-3 align-items-center ms-2">
                                                <p className="mb-0" style={{fontSize: '15px', fontWeight: '500', color: '#545B69'}}>Total Amount :</p>
                                                <p className="mb-0" style={{fontSize: '14px', fontWeight: '500'}}>{selectedDutyFees?.duty_fees}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid rgb(175 172 172)', height: '25px'}}></div>
                                            <div className="d-flex gap-2 align-items-center">
                                                <p className="mb-0" style={{fontSize: '15px', fontWeight: '500', color: '#545B69'}}>Remaining Amount :</p>
                                                <p className="mb-0" style={{fontSize: '14px', fontWeight: '500'}}>{selectedDutyFees?.pending_duty_fees}</p>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3' style={{backgroundColor: '#FAFDFF', border:'1px solid #C3E8FF', borderRadius:'5px', padding:'10px'}}>
                                    <Grid container item xs={12} sm={12} spacing={1}>
                                    <Grid item xs={3}>
                                            <TextField
                                               className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Duty Fee Number"
                                                variant="outlined"
                                                value={options.pay_num}
                                                
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'pay_num')}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%', }}
                                            />
                                           </Grid>
                                           <Grid item xs={3}>
                                            <TextField
                                               className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Duty Fee"
                                                variant="outlined"
                                                value={options.pay_num}
                                                
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'pay_num')}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%', }}
                                            />
                                           </Grid>
                                         <Grid item xs={3}>
                                        {/* <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label={selectedDutyFees?.duty_fees ? "" : "Duty Fee"}
                                                variant="outlined"
                                                value={selectedDutyFees ? selectedDutyFees?.pending_duty_fees : null}
                                                type='number'
                                                disabled={true}
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 300 }}
                                            />
                                        </div> */}
                                        {/* <div className="mb-1"> */}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className='payment_date date_picker_fullwidth'
                                                    label="Date"
                                                    value={dayjs(options.date)}
                                                  onChange={(e) => handleInputChange(e, 'date')}
                                                />
                                            </LocalizationProvider>
                                            {options.date_error && <span className="error-message" style={{ color: 'red' }}>{options.date_error}</span>}
                                           </Grid>
                                        {/* </div> */}
                                        {/* <div className="mb-1"> */}
                                        {/* </div> */}
                                        {/* <div className="mb-1"> */}
                                        <Grid item xs={3}>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Pay Num"
                                                variant="outlined"
                                                value={options.pay_num}
                                                
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'pay_num')}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%', }}
                                            />
                                           </Grid>
                                        {/* </div> */}
                                        {/* <div className="mb-1"> */}
                                        <Grid item xs={3} className="mt-1">
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%' }}
                                                options={bankOptions}
                                                value={options.bank}
                                                onChange={(_, v) => handleInputChange(v, 'bank')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Bank"
                                                    />
                                                )}
                                            />
                                            {options.bank_error && <span className="error-message" style={{ color: 'red' }}>{options.bank_error}</span>}
                                        </Grid>
                                        <Grid item xs={3} className="mt-1">
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Amount"
                                                variant="outlined"
                                                value={options.amount}
                                                onChange={(e) => {
                                                    if(e.target.value >= 0 && e.target.value < 999999999){

                                                    handleInputChange(e.target.value, 'amount')
                                                    }
                                                
                                                }
                                                }
                                                type='number'
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.amount_error && <span className="error-message" style={{ color: 'red' }}>{options.amount_error}</span>}
                                           </Grid>
                                           <Grid item xs={2} className="mt-1">
                                            <TextField
                                               className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Rate"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.rate}
                                                onChange={(e) => {
                                                    if(e.target.value >= 0 && e.target.value < 999999999){

                                                    handleInputChange(e.target.value, 'rate')
                                                    }
                                                }}
                                                type='number'
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.rate_error && <span className="error-message" style={{ color: 'red' }}>{options.rate_error}</span>}
                                         </Grid>
                                        <Grid item xs={2} className="mt-1">
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="FuncAmt"
                                                variant="outlined"
                                                value={options.func_amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 150 }}
                                                sx={{ width: '100%' }}
                                            />
                                            </Grid>
                                            <Grid item xs={2} className="mt-1">
                                            <div className="d-flex align-items-center">
                                            <button className="assign_vendor" disabled={!selectedInvoice || !selectedDutyFees} onClick={toggleModal}>Submit</button>
                                        </div>
                                            </Grid>
                                        </Grid>
                                        {/* </div> */}
                                        {/* <div className="mb-1"> */}
                                            {/* <Grid item xs={2}>
                                        <div className='d-flex align-items-center gap-2'>
                                            <p className="mb-0">Duty Fees Upload</p>
                                            <div className="upload-btn-wrapper ms-2">
                                                <button className="btn">Upload</button>
                                                <input type="file" name="myfile" onChange={(e) => onFileChange(e)} />
                                                {file && <p className="mb-0" style={{ color: "#0060AA" }}>{file.name}</p>}

                                            </div>
                                        </div>
                                        </Grid> */}
                                        {/* </div> */}
                                        {/* <div className="d-flex align-items-center">
                                            <button className="assign_vendor">Submit</button>
                                        </div> */}
                                        {/* </Grid> */}
                                    </div>
                                    {/* <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3'>
                                    
                                        
                                        <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 255 }}
                                                options={bankOptions}
                                                value={options.bank}
                                                onChange={(_, v) => handleInputChange(v, 'bank')}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Bank"
                                                    />
                                                )}
                                            />
                                            {options.bank_error && <span className="error-message" style={{ color: 'red' }}>{options.bank_error}</span>}

                                        </div>
                                        <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Amount"
                                                variant="outlined"
                                                value={options.amount}
                                                onChange={(e) => handleInputChange(e.target.value, 'amount')}
                                                type='number'
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 255 }}
                                            />
                                            {options.amount_error && <span className="error-message" style={{ color: 'red' }}>{options.amount_error}</span>}

                                        </div>
                                        <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Rate"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.rate}
                                                onChange={(e) => handleInputChange(e.target.value, 'rate')}
                                                type='number'
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 255 }}
                                            />
                                            {options.rate_error && <span className="error-message" style={{ color: 'red' }}>{options.rate_error}</span>}

                                        </div>
                                        <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="FuncAmt"
                                                variant="outlined"
                                                value={options.func_amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 255 }}
                                            />
                                        </div>
                                    </div> */}
                                    {/* <div className="d-flex align-items-center mt-2 justify-content-end">
                                            <button className="assign_vendor" disabled={!selectedInvoice || !selectedDutyFees} onClick={toggleModal}>Submit</button>
                                        </div> */}
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                        <div>
                          <h4 className="mb-0 requisition_text">All Duty Fee</h4>
                        </div>
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop: '10px' }}>
                            {/* <h4 className="mb-0 requisition_text">Duty Fee</h4> */}
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={modalIsOpen}
                toggle={toggleModal}
              >
                <div className="d-flex justify-content-between me-2 mt-3">
                  <h4 className="ms-3">
                    Do You Want To Submit This Payment?
                  </h4>
                  <div className="d-flex justify-content-end me-3 modal_close">
                    <i className="ri-close-line" onClick={toggleModal}></i>
                  </div>
                </div>
                <hr className="mb-2 mt-1 ms-3 me-3"></hr>
                <ModalBody className="pt-2">
                <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Payment Mode</th>
                                            <th>Bank</th>
                                            <th>Amount</th>
                                            <th>Rate</th>
                                            <th>Func. Amount</th>
                                        </tr>
                                    </thead>
             

                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{options.payment_type?.value}</td>
                                                <td>{options.bank?.value}</td>
                                                <td>{options.amount}</td>
                                                <td>{options.rate}</td>
                                                <td>{options.func_amount}</td>

                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                  <div className="d-flex align-items-center mt-4 justify-content-center">
                    <button
                      className="yes_button d-flex align-items-center"
                      onClick={handleSubmit}
                    >
                      Yes
                    </button>
                    <button
                      className="no_button d-flex align-items-center ms-3"
                      onClick={toggleModal}
                    >
                      No
                    </button>
                  </div>
                </ModalBody>
              </Modal>
        </React.Fragment>
    );
};

export default DutyFee;
